import { DateTime } from 'luxon';
import { KeyedStreamItem } from 'communication/types/StreamElement';

export enum ShowDataFor {
    AllDay,
    Last30Mins,
    LastHour,
    Last2Hours,
}

export function applyShowDataFor<T extends KeyedStreamItem>(
    items: T[],
    showDataFor?: ShowDataFor
): T[] {
    if (items.length === 0) {
        return items;
    }
    const maxI = Math.max(...items.map((i) => i._i));
    let boundary = DateTime.fromMillis(maxI * 60000);

    switch (showDataFor) {
        case ShowDataFor.Last30Mins: {
            boundary = boundary.plus({ minutes: -30 });
            break;
        }
        case ShowDataFor.LastHour: {
            boundary = boundary.plus({ hours: -1 });
            break;
        }
        case ShowDataFor.Last2Hours: {
            boundary = boundary.plus({ hours: -2 });
            break;
        }
        default:
            return items;
    }

    return items.filter((b) => DateTime.fromMillis(b._i * 60000) >= boundary);
}
